import React, { Component } from 'react'
import {
  NavBar,
  Icon,
  List,
  Checkbox,
  WhiteSpace,
  Button,
  Toast,
} from "antd-mobile";
import axios from "../../../../service/axios";
import http from '../../../../utils/request';
import "./adminPermission.scss";

const CheckboxItem = Checkbox.CheckboxItem;

// @connect(({ admin }) => ({ admin }))
export class AdminPermission extends Component {
  state = {
    permissionList: [],
    defaultPermissions: [],
    checkPermissions: [],
  };
  componentDidMount() {
    this.getAllPermissions();
    this.getUserPermissions();
  }

  // 查询所有可配权限
  getAllPermissions() {
    Toast.loading("加载中...", 0);
    http.get("/api/admin/permission/list", {},'new')
      .then(res => {
        Toast.hide();
        if (res.status == 200) {
          const { data } = res;
          // 移除数组中第一个元素
          data.shift();
          this.setState({
            permissionList: data,
          });
        }
      });
  }

  getUserPermissions() {
    http
      .get("/api/admin/permission/find/adminId", {
        adminId: this.props.match.params.id
      },'new')
      .then(res => {
        if (res.status == 200) {
          const { data } = res;
          let permissions = data.map(item => item.id);
          // const d = data.map(item => item.permissionId);
          this.setState({
            defaultPermissions: permissions,
            checkPermissions: permissions,
          });
        }
      });
  }

  onChange = (e, item) => {
    const { id } = item;
    let arr = this.state.checkPermissions;
    if (e.target.checked) {
      arr.push(id);
    } else {
      arr.splice(arr.map(item => item).indexOf(id), 1);
    }
    this.setState({
      checkPermissions: arr,
      defaultPermissions: arr,
    });
  }

  submit = () => {
    const { checkPermissions } = this.state;
    Toast.loading("处理中...", 0);
    http
      .post("/api/admin/permission/set", {
        permissionIds: checkPermissions,
        targetId: this.props.match.params.id,
      },'new')
      .then(res => {
        Toast.hide();
        if (res && res.status == 200 ) {
          Toast.success('操作成功!', 1);
          setTimeout(() => window.history.go(-1), 1500);
        } else {
          Toast.fail('操作失败!',1);
        }
      });
  }

  render() {
    const { permissionList, defaultPermissions, } = this.state;
    return (
      <div className="main-permission-list">
        <NavBar
          icon={<Icon type="left" />}
          onLeftClick={() => this.props.history.goBack()}
        >
          权限设置
        </NavBar>
        <div className="permission-list">
          <form>
            <List renderHeader={() => '权限列表'}>
              {
                permissionList.map((item, index) => (
                  <CheckboxItem key={item.id} checked={defaultPermissions.includes(item.id)} onChange={e => this.onChange(e, item)}>
                    {item.name}
                  </CheckboxItem>
                ))
              }
            </List>
            <WhiteSpace size="xl" />
            <Button type="primary" onClick={() => this.submit()}>
              确定
            </Button>
            <WhiteSpace size="xl" />
            <Button onClick={() => this.props.history.goBack()}>
              返回
            </Button>
          </form>
        </div>
      </div>
    )
  }
}

export default AdminPermission
